export { generateRiderBenefitData } from './benefit-data'
